import http from 'hub-http/clients/apiClient';
export function fetchEmailReplyHistory(conversationsMessageId, inReplyToDisposition) {
  return http.get(`/conversations-email/v1/app-messages/${conversationsMessageId}/formatted-reply-body`, {
    query: {
      inReplyToDisposition
    },
    headers: {
      Accept: 'text/html'
    }
  });
}